import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { EnumUserRole } from 'lib/graphql';
import { BaseModule } from 'lib/modules';

// Lazy-loaded page components
const NotificationsPage = lazy(() =>
  import(
    /* webpackChunkName: "notifications" */ 'pages/processor/notifications'
  ).then((m) => ({ default: m.NotificationsPage })),
);

const EditNotificationPage = lazy(() =>
  import(
    /* webpackChunkName: "edit-notification" */ 'pages/processor/notifications/edit-notification'
  ).then((m) => ({ default: m.EditNotificationPage })),
);

/**
 * Notifications Module Implementation
 */
class NotificationsModuleClass extends BaseModule {
  id = 'NOTIFICATIONS';
  name = 'Notifications';
  label = 'Notifications';
  description = 'Notification configuration and management';
  version = '1.0.0';
  /**
   * Creates route objects for the Notifications module
   * @param ProtectedRoute
   * @param LazyWrapper
   * @param settings
   * @param ModuleProtectedRoute
   */
  createRoutes = (
    ProtectedRoute: any,
    LazyWrapper: any,
    settings?: any,
    ModuleProtectedRoute?: any,
  ): RouteObject[] => {
    const routes: RouteObject[] = [];
    const RouteProtector = ModuleProtectedRoute || ProtectedRoute;

    // Notifications list
    routes.push({
      path: '/processor/notifications',
      element: (
        <RouteProtector
          component={NotificationsPage}
          moduleId="NOTIFICATIONS"
          allowedUserRoles={[EnumUserRole.Vendor]}
        />
      ),
    });

    // Edit notification
    routes.push({
      path: '/processor/notifications/:id',
      element: (
        <RouteProtector
          component={EditNotificationPage}
          moduleId="NOTIFICATIONS"
          allowedUserRoles={[EnumUserRole.Vendor]}
        />
      ),
    });

    return routes;
  };
}

// Export singleton instance
export const NotificationsModule = new NotificationsModuleClass();
